// src/pages/painel/PainelFloatingButtons.js
import React from 'react';
import './painelFloatingButtons.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faUtensils,
  faCalendarAlt,
  faGear,
} from '@fortawesome/free-solid-svg-icons';

import { useLocation, useNavigate } from 'react-router-dom';

const PainelFloatingButtons = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const irPara = (rota) => {
    if (location.pathname !== rota) {
      navigate(rota);
    }
  };

  const itens = [
    { rota: '/painel', label: 'Painel', icone: faHome },
    { rota: '/calendario', label: 'Calendário', icone: faCalendarAlt },
    { rota: '/cardapios', label: 'Refeições', icone: faUtensils },
    { rota: '/perfil', label: 'Config', icone: faGear },
  ];

  return (
    <nav className="bottom-nav">
      {itens.map((item) => {
        const ativo = location.pathname === item.rota;

        return (
          <button
            key={item.rota}
            className={`bottom-nav-item ${ativo ? 'ativo' : ''}`}
            onClick={() => irPara(item.rota)}
          >
            <FontAwesomeIcon icon={item.icone} className="bottom-nav-icone" />
            <span className="bottom-nav-label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default PainelFloatingButtons;